module.exports = "body {\n  background-color: #fff !important; }\n\n.fc-view-container {\n  background-color: #fff !important; }\n\n.fc-toolbar.fc-header-toolbar {\n  margin-bottom: 0em !important;\n  padding-bottom: 15px; }\n\n.fc-day-grid-event .fc-content {\n  white-space: normal; }\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/calender/calender.component.scss
// module id = ./client/app/calender/calender.component.scss
// module chunks = main